import {createSlice} from '@reduxjs/toolkit';
const initialState = {
  random: null,
  connection: null,
  listLoading: false,
  actionsLoading: false,
  error: null,
  client: null,
  isSubed: null,
  subscription: [],
  payload: null,
  connectStatus: 'Kết nối',
  messages: [],
};
export const callTypes = {
  list: 'list',
  action: 'action',
};

export const globalSlice = createSlice({
  name: 'global',
  initialState: initialState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },

    setRandom: (state, action) => {
      state.random = Math.random().toString(32);
    },
    setConnection: (state, action) => {
      state.connection = action.payload;
    },
    setConnectStatus: (state, action) => {
      state.connectStatus = action.payload;
    },
    setClient: (state, action) => {
      state.client = action.payload;
    },
    setDisconnect: (state, action) => {
      state.connectStatus = 'Kết nối';
      state.client = null;
      /*  if (state.client) {
        try {
          state.client.end(false, () => {
            state.connectStatus = 'Kết nối';
            state.client = null;
            console.log('disconnected successfully');
          });
        } catch (error) {
          console.log('disconnect error:', error);
        } finally {
          state.connectStatus = 'Kết nối';
          state.client = null;
        }
      } */
    },
    sub: (state, action) => {
      state.subscription = [...state.subscription, action.payload];
    },
    unSub: (state, action) => {
      if (state.subscription.length > 0) {
        const newArray = state.subscription.filter((item) => item.topic !== action.payload.topic);
        state.subscription = newArray;
      }
    },
    setMessages: (state, action) => {
      console.log('setmessaete', action.payload);
      state.messages = [...state.messages, action.payload];
    },
    clearMessages: (state, action) => {
      state.messages = [];
    },
  },
});
